module.exports = __webpack_public_path__ + "img/why2.7e1e68eb.png";